type Condition = RegExp | string[] | ((url: string) => boolean);

class RouteService {
  public static checkRouteMatch(condition: Condition): boolean {
    const currentUrl = window.location.href;

    if (Array.isArray(condition)) {
      return condition.length ? condition.some((routePart) => currentUrl.includes(routePart)) : true;
    }

    if (condition instanceof RegExp) {
      return condition.test(currentUrl);
    }

    if (typeof condition === 'function') {
      return condition(currentUrl);
    }

    return false;
  }

  public static matchRouteToPath(routeTemplate: string, path: string): boolean {
    const normalize = (str: string) => str.replace(/^\/+|\/+$/g, '');

    const templateParts = normalize(routeTemplate).split('/');
    const pathParts = normalize(path).split('/');

    if (templateParts.length !== pathParts.length) {
      return false;
    }

    for (let i = 0; i < templateParts.length; i++) {
      const templatePart = templateParts[i];
      const pathPart = pathParts[i];

      if (templatePart.startsWith(':')) continue;
      if (templatePart !== pathPart) return false;
    }

    return true;
  }
}

export default RouteService;
